import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ClientBankAccountValidationService } from 'src/app/services/client-bank-account-validation.service';

@Component({
  selector: 'terra-fedwire-routing-number-field',
  template: `
    <div class="terra-form-field-wrapper">
      <div class="label-container">
        <label class="text-input-label">Wire Routing Number</label>
        <mat-icon class="notranslate" color="primary" matTooltipClass="terra-tooltip" matTooltipPosition="right" matTooltip="{{ tooltip }}">help</mat-icon>
      </div>
      <mat-form-field class="field-title" appearance="outline">
        <input
          type="tel"
          autocomplete="off"
          matInput
          [placeholder]="placeholder"
          [formControl]="control"
          [required]="requiredField"
          class="lo_sensitive"
        />
        <mat-error *ngIf="control.hasError('required')">Required</mat-error>
        <mat-error *ngIf="control.hasError('pattern')">Please insert a valid Wire Routing Number</mat-error>
      </mat-form-field>
      
    </div>
  `,
  styles: [`
    .label-container { 
      display: flex; 
      gap: 6px;
    }
    .text-input-label {
      width: fit-content;
    }
    .label-container > mat-icon.mat-icon {
      color: #9ea5ad;
      font-size: 18px;
      width: initial;
      height: initial;
      padding: initial;
      margin: initial;
      top: 6px;
      position: relative;
    }
  `]
})
export class FedwireRoutingNumberFieldComponent implements OnInit {
  @Input()
  public requiredField: boolean;
  @Input()
  public placeholder: string;
  @Input()
  public control: UntypedFormControl;
  @Input()
  public hint: string;

  public tooltip =
  "The WIRE code is a 9-digit code used for high-value wire transfers within the United States. You can often find it on your bank statements or at the bottom of your checks, just before your account number. It is typically the second 9-digit sequence following your ACH routing number.";

  constructor(private validationService: ClientBankAccountValidationService) {}

  ngOnInit(): void {
    this.control.valueChanges
      .subscribe(val => {
        if (val !== null && val !== undefined && val.length > 0) {
          this.control.setErrors({ pattern: false });
          const validationResult = this.validationService.validateUSABARoutingNumberField(val);
          if (
            validationResult !== null &&
            validationResult !== undefined &&
            validationResult.patterns !== null &&
            validationResult.patterns !== undefined &&
            validationResult.patterns.length > 0
          ) {
            this.control.setErrors({ pattern: true });
          } else {
            this.control.updateValueAndValidity({emitEvent: false});
          }
        } else {
          this.control.updateValueAndValidity({emitEvent: false});
        }
      });
  }
}
